var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 265,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6667 92.3333C83.6667 79.2493 88.8643 66.7012 98.1161 57.4494C107.368 48.1976 119.916 43 133 43C146.084 43 158.632 48.1976 167.884 57.4494C177.136 66.7012 182.333 79.2493 182.333 92.3333C182.333 105.417 177.136 117.965 167.884 127.217C158.632 136.469 146.084 141.667 133 141.667C119.916 141.667 107.368 136.469 98.1161 127.217C88.8643 117.965 83.6667 105.417 83.6667 92.3333ZM83.6667 166.333C67.3116 166.333 51.6265 172.83 40.0617 184.395C28.497 195.96 22 211.645 22 228C22 237.813 25.8982 247.224 32.8371 254.163C39.7759 261.102 49.187 265 59 265H207C216.813 265 226.224 261.102 233.163 254.163C240.102 247.224 244 237.813 244 228C244 211.645 237.503 195.96 225.938 184.395C214.374 172.83 198.688 166.333 182.333 166.333H83.6667Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarImg);
export default __webpack_public_path__ + "static/media/avatar-img.99f7838d42c00001e9a0ddb248c8f5b8.svg";
export { ForwardRef as ReactComponent };